import Vue from 'vue';

/** Event bus for sending issue time bar and issue troubleshooting events. */
const IssueTimeBarEventBus = new Vue();

export default IssueTimeBarEventBus;
